module.exports = __webpack_public_path__ + "img/goal-target_reduce.85d2a9e.svg";